import SjQuestionInlineRichText from './src/SjQuestionInlineRichText.vue'

export default SjQuestionInlineRichText



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-inline-rich-text/index.js